import { supabase } from '@/supabase/client'; // Assuming this is your Supabase client instance

// Define the expected return type for loyal customers
export interface LoyalCustomer {
  customer_nickname: string;
  order_count: number;
}

// Define the expected return type for top products
export interface TopProduct {
  product_item_name: string;
  total_quantity_sold: number;
  // total_revenue?: number; // Add if you implement revenue calculation in RPC
}

const ANALYTICS_DATA_LIMIT = 5; // Number of top items to fetch

/**
 * Fetches the top loyal customers based on order count.
 * @param limit - The number of top customers to fetch.
 * @returns A promise that resolves to an array of LoyalCustomer objects.
 */
export const fetchLoyalCustomersByCount = async (limit: number = ANALYTICS_DATA_LIMIT): Promise<LoyalCustomer[]> => {
  const { data, error } = await supabase.rpc('get_loyal_customers_rpc', {
    p_limit: limit,
  });

  if (error) {
    console.error('Error fetching loyal customers:', error);
    throw error;
  }

  return data || [];
};

/**
 * Fetches the top-selling products based on total quantity sold.
 * @param limit - The number of top products to fetch.
 * @returns A promise that resolves to an array of TopProduct objects.
 */
export const fetchTopProductsAllTime = async (limit: number = ANALYTICS_DATA_LIMIT): Promise<TopProduct[]> => {
  const { data, error } = await supabase.rpc('get_top_products_rpc', {
    p_limit: limit,
  });

  if (error) {
    console.error('Error fetching top products:', error);
    throw error;
  }

  return data || [];
};